import z from "zod";

const mcpErrorTypeValues = ["TOOL_NOT_FOUND", "INVALID_INPUT", "INVALID_CONTEXT", "BID_NOT_FOUND"] as const;

const mcpErrorTypeSchema = z.enum(mcpErrorTypeValues);
const McpErrorType = mcpErrorTypeSchema.enum;
type McpErrorType = z.infer<typeof mcpErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type McpErrors =
  | {
      errorType: typeof McpErrorType.TOOL_NOT_FOUND;
      data: {
        toolName: string;
      };
    }
  | {
      errorType: typeof McpErrorType.INVALID_INPUT;
      data: {
        errors?: unknown;
      };
    }
  | {
      errorType: typeof McpErrorType.INVALID_CONTEXT;
      data: Record<string, never>;
    }
  | {
      errorType: typeof McpErrorType.BID_NOT_FOUND;
      data: {
        id: number;
      };
    };

export const mcpErrorDetails: Record<McpErrorType, ErrorDetails> = {
  [McpErrorType.TOOL_NOT_FOUND]: {
    sentryDescription: "MCP tool not found",
  },
  [McpErrorType.INVALID_INPUT]: {
    sentryDescription: "Invalid input provided to MCP tool",
  },
  [McpErrorType.INVALID_CONTEXT]: {
    sentryDescription: "Missing or invalid context in MCP request",
  },
  [McpErrorType.BID_NOT_FOUND]: {
    sentryDescription: "Bid not found",
  },
};
